import React from 'react'
import { Person } from 'types/globalTypes'

interface PersonalDetailsProps {
  user: Person
  title: string
}

const PersonalDetails: React.FC<PersonalDetailsProps> = ({ user, title }) => {
  return (
    <div>
      <div className="flex flex-col justify-end">
        <h4 className="text-12 w-600 text-gray">{title}</h4>
        <p className="text-14 w-500 text-end">{`${user.firstName} ${user.lastName}`}</p>
      </div>
    </div>
  )
}

export default PersonalDetails
